import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PeriodicElement } from '../project-list/project-list.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { environment } from '../../../environments/environment';
import { MatSort } from '@angular/material/sort';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from '../../api.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auditor',
  templateUrl: './auditor.component.html',
  styleUrls: ['./auditor.component.css']
})
export class AuditorComponent {
  @Input() dataSource: MatTableDataSource<PeriodicElement>;
  @Input() canView: boolean;
  @Input() canEdit: boolean;
  @Input() canDelete: boolean;
  @Input() canAssignCoordinator: boolean;
  @Input() canInitiateProject: boolean;
  @Input() canViewLogs: boolean;
  displayedColumns: string[] = ['project', 'client', 'regDate', 'status', 'type', 'coordinator', 'actions'];
  @Output() view = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() initiate = new EventEmitter<any>();
  @Output() assignUser = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  datas: any;
  redirectUrl = environment.redirect.clientRedirectUrl;
  schoolUrl = environment.redirect.school_griha_url;
  jangrihaUrl = environment.redirect.jan_griha_url;
  watergrihaUrl = environment.redirect.water_griha_url;
  wastegrihaUrl = environment.redirect.waste_griha_url;
  idTokenData: any;
  accessTokenData: any;
  userInfo: any;
  role: any;
  emailId: string;
  projectCode: any = ''
  clientId: any = '';
  auditorInfo: any;
  pageIndex: number = 0;
  pageSize: number = 5;
  totalItems: number = 0;
  
  @ViewChild(MatPaginator) matPaginator!: MatPaginator;
  @ViewChild(MatSort) matSort!: MatSort;
  
  data: any;

  constructor(private auth: AuthService, private service: ApiService, private http: HttpClient, private router: Router) {
    console.log('Auditor component initialized');
    console.log('redirect url',this.redirectUrl);
  }

  ngOnInit() {
    if (localStorage.getItem('auditorInfo')) {
      this.auditorInfo = localStorage.getItem('auditorInfo');
      const params={
        page:(this.pageIndex+1).toString(),
        list_size:this.pageSize.toString(),
        status:'INITIATED',
        auditor:this.auditorInfo
      }
      this.getProjectList(params);
  
    }
    else {
      window.location.href = environment.logoutUrl;
    }
  }

  getProjectList(params:any){
    console.log(params);
    this.dataSource=new MatTableDataSource();
    this.service.getProjectListByClient(params).subscribe((data) => {
      this.data = data

      this.totalItems=this.data.totalItems;
      this.dataSource = this.data.data;
      
      if (this.matPaginator) {
        this.dataSource.paginator = this.matPaginator;
      }
      this.dataSource.sort = this.matSort;

      this.auth.idTokenClaims$.subscribe(idToken => {
        this.idTokenData = idToken?.__raw
        console.log(this.idTokenData)

        this.auth.getAccessTokenSilently().subscribe(accessToken => {
          this.accessTokenData = accessToken
        });
      })

    });

  }


  onPageChange(event:PageEvent){
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const params={
      page:this.pageIndex+1,
      list_size:this.pageSize,
      status:'INITIATED',
      role:'Auditor'
    }
    this.getProjectList(params);
  }

  onDelete = (rowData: any) => {
    this.delete.emit(rowData);
    console.log(rowData)
  }

  onEdit = (rowData: any) => {
    this.edit.emit(rowData);
  }

  onView = (rowData: any) => {
    this.view.emit(rowData);
  }
  onInitiate = (rowData: any) => {
    this.initiate.emit(rowData);
  }


  onAssignUser = (rowData: any) => {
    this.assignUser.emit(rowData)
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  move() {
    let redirectLocation = `${this.redirectUrl}`
    window.location.href = `${redirectLocation}`;
  }

  rowData(e: any) {
    console.log(e)
    console.log(e.project_code)
    let redirectLocation = '';
    if (e['app']['application_code'] === 'G001V001') {
      redirectLocation = `${this.redirectUrl}/section/${e.project_code}/project-details/`;
    } else if(e['app']['application_code'] === 'G003V001'){
      redirectLocation = `${this.jangrihaUrl}/auditor/${e.project_code}`;
    } else if(e['app']['application_code'] === 'G004V001'){
      redirectLocation = `${this.watergrihaUrl}/auditor/${e.project_code}`;
    } else if (e['app']['application_code'] === 'G006V001') {}
    else if (e['app']['application_code'] === 'G007V001') {
      redirectLocation = `${this.wastegrihaUrl}/auditor/${e.project_code}`;
    }else if (e['app']['application_code'] === 'G002V001') {
      redirectLocation = `${this.schoolUrl}/auditor/section/${e.project_code}/project-details/`;
    }
    console.log(redirectLocation);
    window.location.href = redirectLocation;
  }
}
